import React from 'react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="border-b border-line bg-surface py-24 lg:py-32 space-y-[15px]" style={{
    paddingTop: "5px",
    paddingBottom: "5px"
  }} data-id="element-25" data-mp="vf65316ilxma">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-26" data-mp="19fqpg1s2w1hw">
        <h2 className="font-serif text-3xl font-semibold leading-tight tracking-tight text-forest sm:text-[2.6rem]" data-id="element-27" data-mp="15dlxr8l6xexw">
          Letzte Chance: Sichere dir dein Diagnose-Handbuch mit allen 5 Bonos
        </h2>

        <div className="mx-auto mt-7 max-w-2xl space-y-5 text-lg leading-relaxed text-prose" data-id="element-28" data-mp="1eejyni0c16c9">
          <p data-id="element-29" data-mp="1t3g4r9itw9a8">In 60 Sekunden wirst du das Wissen haben, das dein Urban-Farming-System 10 Jahre voraus ist.</p>
          <p data-id="element-30" data-mp="1o3lgzeucnzte">Keine weiteren Fehldiagnosen. Keine verlorenen Ernten. Keine Frustration.</p>
          <p className="font-medium text-forest" data-id="element-31" data-mp="2233ag7ilc193">Nur klinische, präzise, visuelle Diagnose. Jedes Mal.</p>
        </div>

        <CtaButton label="SOFORTIGER DOWNLOAD: JETZT STARTEN" className="mt-10 w-full sm:w-auto" data-id="element-32" data-mp="1x5kxm61gd1vt" />

        <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-prose" data-id="element-33" data-mp="n6nr2ye1q4ws">
          7 Tage Geld-zurück-Garantie. Wenn dir das Handbuch nicht innerhalb von 7 Tagen mindestens ein Problem erspart hat, bekommst du 100 % zurück. Keine Fragen.
        </p>
      </div>
    </section>;
}